export default __webpack_public_path__ + "static/media/danilo_new.d0a2859b.jpg";